export const paperMain = (isMobile) => ({
  p: isMobile ? 2 : 4,
  mb: isMobile ? 2 : 4,
  border: '1px solid #e0e0e0',
  borderRadius: 2,
  backgroundColor: 'white',
});

export const paperInfo = (isMobile) => ({
  p: isMobile ? 2 : 4,
  mb: isMobile ? 2 : 4,
  border: '1px solid #e0e0e0',
  borderRadius: 2,
  backgroundColor: '#fafafa',
});

export const paperAttachments = (isMobile) => ({
  border: '1px solid #e0e0e0',
  borderRadius: 2,
  overflow: 'hidden',
  mb: isMobile ? 2 : 4,
});

export const attachmentsList = {
  maxHeight: '300px',
  overflow: 'auto',
  backgroundColor: '#f8f9fa',
};

export const attachmentItem = (isSelected) => ({
  p: 2,
  border: 'none',
  borderBottom: '1px solid #e0e0e0',
  backgroundColor: isSelected ? 'primary.light' : 'transparent',
  color: isSelected ? 'primary.contrastText' : 'text.primary',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: isSelected ? 'primary.main' : 'action.hover',
  },
  '&:last-child': {
    borderBottom: 'none',
  },
});

export const attachmentViewer = {
  border: '1px solid #e0e0e0',
  borderRadius: 2,
  overflow: 'hidden',
};

export const viewerToolbar = {
  p: 2,
  borderBottom: '1px solid #e0e0e0',
  bgcolor: 'grey.50',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const viewerContainer = (isFullscreen) => ({
  height: isFullscreen ? '80vh' : 'auto',
  minHeight: isFullscreen ? 'auto' : '60vh',
  maxHeight: isFullscreen ? 'auto' : '80vh',
  bgcolor: 'white',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  overflow: 'auto',
  p: 2,
});

export const viewerPager = {
  p: 2,
  borderTop: '1px solid #e0e0e0',
  backgroundColor: '#f8f9fa',
  display: 'flex',
  justifyContent: 'center',
  gap: 2,
};

export const noAttachmentMessage = {
  p: 4,
  textAlign: 'center',
  color: 'text.secondary',
  backgroundColor: '#f8f9fa',
  border: '1px solid #e0e0e0',
  borderRadius: 2,
  minHeight: '200px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
};

export const attachmentIcon = {
  fontSize: '3rem',
  mb: 2,
  opacity: 0.5,
};